import { snakeCase, camelCase } from 'lodash';

export default camelCase;

export function convertObjectKeysToSnakeCase(
  object: { [key: string]: any },
  keysToConvert: string[]
) {
  return keysToConvert.reduce<{ [key: string]: any }>((prev, curKey, index, array) => {
    prev[snakeCase(curKey)] = object[curKey];
    delete object[curKey];
    return prev;
  }, object);
}
